import { Table, Tbody, Text, Th, Thead, Tr } from '@chakra-ui/react';
import { Product } from 'shared/models/product';
import ServiceTableLine from '../molecules/ServiceTableLine';

interface ContractServicesTableProps {
  loading?: boolean;
  services?: Product[];
}
const ContractServicesTable = ({
  loading,
  services,
}: ContractServicesTableProps) => {
  const serviceSkeletonList = Array.from({ length: 3 });
  return (
    <Table
      variant="simple"
      sx={{
        'thead tr th': {
          fontWeight: 'normal',
          color: '#1A202C',
        },
        'tbody tr td': {
          fontWeight: 'normal',
          color: '#1A202C',
        },
      }}
    >
      <Thead opacity={loading ? '.3' : ''}>
        <Tr>
          <Th>Nome</Th>
          <Th>Valor</Th>
          <Th>Desconto</Th>
          <Th>Ciclos do desconto</Th>
          <Th>Criado em</Th>
          <Th w="10px"></Th>
        </Tr>
      </Thead>
      <Tbody>
        {loading ? (
          serviceSkeletonList.map((_, index) => (
            <ServiceTableLine key={index} loading={true}></ServiceTableLine>
          ))
        ) : services?.length ? (
          services.map((service) => (
            <ServiceTableLine
              key={service.id}
              service={service}
            ></ServiceTableLine>
          ))
        ) : (
          <Tr>
            <Text my={'0.5rem'}>Nenhum serviço encontrado</Text>
          </Tr>
        )}
      </Tbody>
    </Table>
  );
};
export default ContractServicesTable;
